<template>
  <v-container fluid fill-height>   
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card flat>          
          <v-card-title>
            <div class="login__title">
              <h3>
                Återförsäljarlogin
                <span class="login-close">
                  <v-icon class="icon">
                    close
                  </v-icon>                
                </span>
              </h3>
            </div>            
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation color="primary">             
              <v-text-field 
                v-model="userName"                               
                name="login"
                label="Kundnummer"                
                :rules="[v => !!v || 'Kundnummer måste anges']"                
                outlined
              >
                <template v-slot:prepend-inner>
                  <v-icon color="primary">
                    mdi-login
                  </v-icon>
                </template>
              </v-text-field>
              
              <v-text-field                  
                id="password"                   
                v-model="password"
                label="Pinkod"                
                type="password"
                class="input input__field__input"
                name="password"
                required=""                
                outlined
              >
                <template v-slot:prepend-inner>
                  <v-icon color="primary">
                    mdi-lock-open-variant-outline
                  </v-icon>
                </template>
              </v-text-field>
            </v-form>
            <span v-if="!valid" style="color:red">{{ message }}</span>
          </v-card-text>
          <v-card-actions>
            <button
              type="submit"
              form="user-login"
              value="submit"
              class="button button--primary uppercase js-login mdc-ripple-upgraded"
              @click="login"
            >
              <span class="button__label">Logga in</span>
            </button>
            <!-- <SpinnerButton ref="loginButton" label="Logga in" @click="login" /> -->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { setAuthHeader } from '@/backend/axios'
import { mapState, mapMutations } from 'vuex'
import { APP_VERSION, APP_MODE } from '@/store/appStates'
import { SET_USER } from '@/store/appMutations'

import api from '@/backend/api'
import log from '@/logger'
import settings from '@/model/settings'

export default {
  name: 'Login',
  components: {  },
  data() {
    return {
      valid: true,
      userName: settings.login.userName,
      password: settings.login.password,
      message: null
    }
  },
  computed: {
    ...mapState({
      version: state => state[APP_VERSION],      
      isApp:state => state[APP_MODE]
    })
  },
  created(){
    const token = this.$route.query.token
    if( token !== undefined){
      const validateToken = {
          token: token
        }
      api.validate(validateToken)
          .then(resp => {
            this.setUser(resp.data)            
            const token = resp.data.token             
            log.debug('Setting token:', token)
            if(this.$cookies.get('auth_token') === undefined){
              this.$cookies.set('auth_token',token, null,null, 'kvallstidningarna.se')
            }
            setAuthHeader(this.token)
            this.$emit('AUTHORIZED')
          })
          .catch(err => {
            this.valid = false
            if (err.response && err.response.status === 400) {
              this.message = err.response.data
            }
            this.$refs.loginButton.cancel()
          })        
    }
        // close login if click close icon
       
  },
   mounted() {
     document.querySelector('.login-close').addEventListener('click', () => this.handleLoginBoxClose())
  },
  methods: {
    ...mapMutations({
      setUser: SET_USER
    }),
     handleLoginBoxClose(){
      document.getElementById('mega-nav-5').checked = false
    },
    
    login() {
      var self = this
      if (self.$refs.form.validate()) {
        self.valid = true
       
        const regexExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi
        if(regexExp.test(self.userName)){
           const credentials = {
          username: self.userName,
          password: self.password
        }
          api.loginAdmin(credentials)
            .then(resp => {
              self.setUser(resp.data.user)
              const token = resp.data.token            
              log.debug('Setting token:', token)
              if(self.$cookies.get('auth_admin_token') === null){
                self.$cookies.set('auth_admin_token',token, null,null, 'kvallstidningarna.se')
              }
              setAuthHeader(this.token)
              // setTimeout(() => {
              //   if(self.$refs.loginButton !== undefined){
              //     self.$refs.loginButton.cancel()
              //   }
              //   self.$emit('AUTHORIZED')
              // }, 1500)
              self.$emit('AUTHORIZED')
              this.handleLoginBoxClose()
            })
            .catch(err => {
              self.valid = false
              if (err.response && err.response.status === 400) {
                self.message = err.response.data
              }
              //self.$refs.loginButton.cancel()
            })

          // postData('/api/account/login', credentials)
          //   .then(resp => {
          //     console.log('Setting User:', resp)
          //     this.setUser(resp)
          //   })
          //   //.then(user => this.setUser(user))        
        }else{
         const credentials = {
          customerId: self.userName,
          pinCode: self.password
        }
          api.login(credentials)
            .then(resp => {
              self.setUser(resp.data)
              const token = resp.data.token            
              log.debug('Setting token:', token)
              if(self.$cookies.get('auth_token') === null){
                self.$cookies.set('auth_token',token, null,null, 'kvallstidningarna.se')
              }
              setAuthHeader(this.token)
              // setTimeout(() => {
              //   if(self.$refs.loginButton !== undefined){
              //     self.$refs.loginButton.cancel()
              //   }
              //   self.$emit('AUTHORIZED')
              // }, 1500)
              self.$emit('AUTHORIZED')
              this.handleLoginBoxClose()
            })
            .catch(err => {
              self.valid = false
              if (err.response && err.response.status === 400) {
                self.message = err.response.data
              }
              //self.$refs.loginButton.cancel()
            })

          // postData('/api/account/login', credentials)
          //   .then(resp => {
          //     console.log('Setting User:', resp)
          //     this.setUser(resp)
          //   })
          //   //.then(user => this.setUser(user))
        }
      } else {
        self.$refs.loginButton.cancel()
      }    
    }
  }
}
</script>

<style lang="scss" scoped>
.font-weight-light {
  font-family: 'Tidningsretur Normal'
}
.font-weight-bold {
  font-family: 'Tidningsretur Bold'
}
</style>
